// Configuration centrale de La Traversée
// -------------------------------------------------------------
// Mode d'intégration des formulaires : 'native' | 'fluentforms'
// - native      : formulaire React connecté au backend (MongoDB + CRM plus tard)
// - fluentforms : la page WordPress remplacera le formulaire par un shortcode
export const FORM_INTEGRATION_MODE = "native";

// [FLUENT FORM ID] — shortcode fourni : [fluentform id="60"]
export const FLUENT_FORM_ID = "60";

// Vidéo de fond du hero (optionnelle). Vide => grande photographie animée subtilement.
// Ne jamais charger de vidéo 4K sur mobile. Poster = image hero.
export const HERO_VIDEO_URL = "";

// Liens post-inscription (placeholders tant qu'ils ne sont pas fournis)
export const PRIVATE_GROUP_URL = "https://www.facebook.com/groups/1065200142660385/"; // Groupe privé Facebook
export const THANK_YOU_PAGE_URL = ""; // [URL DE LA PAGE DE CONFIRMATION]

// Analytics (aucun vrai identifiant en clair) — injectés par la bannière cookies WP
export const GA4_MEASUREMENT_ID = ""; // GA4_MEASUREMENT_ID
export const META_PIXEL_ID = ""; // META_PIXEL_ID

// Dates de l'expérience
export const DATE_DEBUT = "23 septembre 2026";
export const DATE_FIN = "30 septembre 2026";
export const DATES_COURTES = "23 → 30 sept. 2026";

// Dates ISO pour le rappel auto-actualisé (sans fausse urgence)
export const EVENT_START_ISO = "2026-09-23T00:00:00";
export const EVENT_END_ISO = "2026-09-30T23:59:59";
